module.exports = __webpack_public_path__ + "static/img/dynamicv.cecfed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicv.png
// module id = 2aoI
// module chunks = 45